const ERROR_MESSAGE = {
    "TR": {
        "9000": "Bu işlemi yapabilmek için yetkiniz bulunmamaktadır",
        "9001": "SURVEY_NOT_CLOSED",
        "9002": "Kayıt Bulunamadı",
        "9003": "Rapor daha önce hazırlandı",
        "9004": "Çıkış yapılacak stok miktarı mevcut stok miktarının üstündedir",
        "9005": "İşlem daha önce gerçekleştirildi",
        "9006": "Kod alanı boş olamaz",
        "9007": "İsim alanı boş olamaz",
        "9008": "Miktar boş ve sıfırdan küçük olamaz",
        "9009": "Depo alanı boş olamaz",
        "9010": "Alt eşik alanı boş veya sıfırdan kücük olamaz",
        "9011": "Marka alanı boş olamaz",
        "9012": "Birim alanı boş olamaz",
        "9013": "Fiyat alanı boş ve sıfırdan küçük olamaz",
        "9014": "Birim alanı boş olamaz",
        "9015": "Adres alanı boş olamaz",
        "9016": "Depo bulunamadı",
        "9017": "Marka bulunamadı",
        "9018": "Admin kullanıcısına ait bilgileri güncellemek/silmek için yetkiniz bulunmamaktadır",
        "9019": "Satın alma bulunamadı",
        "9020": "Bu kullanıcı adına ait kullanıcı bulunmaktadır.",
        "9021": "Bu teklife ait Sevkiyat Emri Bulunmaktadır",
        "9022": "Bu isim/kod ile kayıtlı stok bulunmaktadır",
        "9023": "Bu kod ile açılmış kayıt bulunmaktadır",
        "9024": 'Depo girişi olan satın alma silinemez',
        "9025": 'Stok Boş Olamaz',
        "9026": 'Birden fazla depo stoğu servis ile verilemez.',
    },
    "ENG": {}
}
export default ERROR_MESSAGE
